import React from 'react';

import {TypeLocalNameEnum} from 'domain/usecases';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Filter} from 'presentation/components/Filter';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useRecoilQuery} from 'recoil-toolkit';
import {FlowEnum} from '../../constants';
import {bookingSpecialtiesState} from '../../pages/SpecialtySelection/atoms';
import {FilterByLetterProps} from './types';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

export function FilterByLetter({flowType}: FilterByLetterProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;
	const isUsingGeolocation = !bookingData?.isManualLocation;
	const isExam = flowType === FlowEnum.EXAM;
	const isHealth = flowType === FlowEnum.HEALTH;

	const {
		data: specialtiesList,
		loading: LIST_LOADING,
		error: LIST_HAS_ERROR,
	} = useRecoilQuery(
		bookingSpecialtiesState({
			flowType,
			cityName:
				bookingData.isManualLocation || isExam
					? bookingData.cityName?.toUpperCase()
					: bookingData.coordinates,
			ufCode: isUsingGeolocation && isHealth ? '' : bookingData.ufCode?.toUpperCase(),
			typeLocalName:
				isUsingGeolocation && isExam ? TypeLocalNameEnum.CIDADE : bookingData.typeLocalName,
		}),
	);

	const NOT_FOUND = !specialtiesList || specialtiesList.length === 0;
	const HIDDEN_FILTER_BY_LETTER = LIST_HAS_ERROR || LIST_LOADING || NOT_FOUND;
	if (HIDDEN_FILTER_BY_LETTER) {
		return null;
	}

	const FILTERED_LIST_BY_CATEGORY = specialtiesList.map(specialty => ({
		...specialty,
		list: specialty.list.filter(item =>
			item.formattedText.toLowerCase().includes(query.trim().toLowerCase()),
		),
	}));

	return (
		<Filter.Letter
			dataTagId={AppointmentBookingEnum.CLICK_FILTRAR_ESPECIALIDADE}
			filteredList={FILTERED_LIST_BY_CATEGORY}
		/>
	);
}
